<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <v-card
      flat
      tile
      class="pa-3"
    >
      <v-toolbar
        flat
      >
        <v-btn
          icon
          to="/subsidy"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('Subsidy.MarriageSubsidy') }}
        </v-toolbar-title>
      </v-toolbar>

      <v-row>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="form.approver"
            :label="$t('Subsidy.Sender')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="form.name"
            :label="$t('TrainingClient.Identity.name')"
            disabled
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="form.position"
            :label="$t('Subsidy.CategoryOrCareer')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="form.department"
            :label="$t('Subsidy.Subunit')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <s-date-picker
            v-model="form.inGovDate"
            :label="$t('Subsidy.StartCareerDate')"
            :rules="rules.date"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <s-date-picker
            v-model="form.marriageDate"
            :label="$t('Subsidy.MarryDate')"
            :rules="rules.date"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-switch
            v-model="form.isMarriageLocalRegister"
            :label="`${form.isMarriageLocalRegister ? $t('Subsidy.Marriage.LocalRegistration') : $t('Subsidy.Marriage.NonLocalRegistration')}`"
          />
        </v-col>
      </v-row>

      <!--  <s-file-uploader post-url="/upload/post" /> -->
      <h3 class="red--text">
        {{ $t('Subsidy.Marriage.NoticeContent') }}
      </h3>
      <br>
      <v-btn
        color="primary"
        class="ml-0"
        :loading="loading"
        @click="submit"
      >
        {{ $t('Text.Submit') }}
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>

import SDatePicker from '../../components/SDatePicker'
import g2eApi from '../../api/hr/g2e'
import subsidyApi from '../../api/subsidy/subsidy'
import datetimeUtil from '../../utils/datetimeUtil'
import VuetifyJetValidator from 'vuetify-jet-validator'
import { SIGN_CB_URL, LOADING_TIMEOUT } from '../../constant/constant'
import signHelper from '../../helper/signHelper'
import { codeTableModule } from '../../store/moduleName'
import store from '../../store'
import codeTable from '../../store/modules/hr/codeTable'
import { mdiArrowLeft } from '@mdi/js'

const globalModule = 'global'

if (!store.state[codeTableModule]) store.registerModule(codeTableModule, codeTable)

function replacer (key, value) {
  // todo: change only date object
  if (['inGovDate', 'marriageDate'].indexOf(key) >= 0) {
    return JSON.stringify(value).substr(1, 10) + ' 00:00:00'
  }
  return value
}

export default {
  components: {
    SDatePicker
    // SFileUploader
  },
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      mdiArrowLeft: mdiArrowLeft,
      loading: false,
      form: {
        assignedToEuid: null,
        callbackUrl: null,
        name: '',
        position: null,
        department: null,
        inGovDate: null,
        isMarriageLocalRegister: true,
        marriageDate: null,
        approver: this.$t('Subsidy.DirectorOrSubdirector'),
        remark: null
      },
      rules: {
        date: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
    }
  },
  watch: {
  },
  created () {
    g2eApi.getStaff(staff => {
      this.form.name = this.$chPtObjData('chinName', staff)
      this.form.position = this.$chPtObjData('careerChinDesc', staff)
      this.form.department = this.$chPtObjData('entityChinName', staff)
      // this.form.inGovDate = datetimeUtil.cutTime(staff.inGovDate)
      this.form.inGovDate = staff.inGovDate
    })
    if (!this.$store.state[codeTableModule].pubHolidays.length || this.$store.state[codeTableModule].pubHolidays.length < 1) {
      this.$store.dispatch(codeTableModule + '/getPubHolidays')
    }
  },
  methods: {
    submit: function () {
      if (this.form.marriageDate === null) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Subsidy.MarryDate')]))
        return
      }
      if (this.form.inGovDate === null) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Subsidy.StartCareerDate')]))
        return
      }
      if (this.form.inGovDate > this.form.marriageDate) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Subsidy.Marriage.Error.ShouldMarryAfterCareer'))
        return
      }
      let tMarriageDate = datetimeUtil.yyyyMmDdToDate(this.form.marriageDate)
      if (datetimeUtil.dayDiff(tMarriageDate, new Date()) > 60) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Subsidy.Marriage.Error.ShouldWithin60Days'))
        return
      }
      this.loading = true
      this.form.callbackUrl = SIGN_CB_URL
      let postForm = JSON.stringify(this.form, replacer)
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = subsidyApi.marriageSignLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = subsidyApi.marriageSignAndStartWorkflowUrl
      signObj[signHelper.REDIRECT_PATH] = '/subsidy'
      signObj[signHelper.POST_FORM] = postForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'Subsidy.Marriage.AppForm.SuccessMessage'
      signObj[signHelper.FAIL_MSG_KEY] = 'Subsidy.AppForm.FailMessage'

      signHelper.signAndStartWorkflow(signObj)
      setTimeout(() => {
        this.loading = false
      }, LOADING_TIMEOUT)
    }
  }
}
</script>
